module.exports = __webpack_public_path__ + "img/hall-card-blue-tall.9da77dac.png";